import React from 'react';
import { Bell } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { NotificationDropdown } from './NotificationDropdown';
import { useNotifications } from '@/hooks/useNotifications';
import { useAuth } from '@/hooks/useAuth';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { statePop } from '@/lib/motion/presets';

export const NotificationBell: React.FC = () => {
  const { user } = useAuth();
  const { unreadCount } = useNotifications();
  const [open, setOpen] = React.useState(false);
  const reducedMotion = useReducedMotion();

  // No session, no notifications — keep member chrome out of public pages.
  if (!user) return null;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="relative h-11 w-11 md:h-10 md:w-10"
          aria-label="Notifications"
        >
          <Bell className="h-5 w-5" />
          <AnimatePresence initial={false}>
          {unreadCount > 0 && (
            <motion.span
              key="unread-badge"
              className="absolute -top-1 -right-1 h-5 min-w-5 rounded-full bg-destructive text-destructive-foreground text-xs flex items-center justify-center font-medium px-1"
              initial={reducedMotion ? false : 'hidden'}
              animate="show"
              exit="exit"
              variants={statePop}
            >
              {unreadCount > 9 ? '9+' : unreadCount}
            </motion.span>
          )}
          </AnimatePresence>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[min(384px,calc(100vw-1rem))] p-0" align="end">
        <NotificationDropdown onClose={() => setOpen(false)} />
      </PopoverContent>
    </Popover>
  );
};
